import { validEnglishWords } from "./dictionary";
import { validSpanishWords } from "./spanishDictionary";
export const isEnglishWordValid = (word) => {
    if (validEnglishWords.includes(word)) {
        return true;
    }
    return false;
};
export const isSpanishWordValid = (word) => {
    if (validSpanishWords.includes(word)) {
        return true;
    }
    return false;
};
